exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.hide[data-v-645e80f9] {\n    max-width: 0;\n    max-height: 0;\n    opacity: 0;\n    overflow: hidden;\n}\n.border-button[data-v-645e80f9] {\n    border-top-right-radius: 0.2rem !important;\n    border-bottom-right-radius: 0.2rem !important;\n}\n.enlarge[data-v-645e80f9] {\n    transform-origin: center;\n    transform: scale(1.5);\n}\n", ""]);

// exports
